import React from "react";
import { useTranslations } from "next-intl";
import { ErrorComponent, ErrorComponentProps } from "@components/errors/error-component";

export const NotAuthorized = (props: ErrorComponentProps) => {
  const t = useTranslations("common.errors");

  return (
    <ErrorComponent
      title={t("notAuthorized.title")}
      subTitle={t("notAuthorized.subTitle")}
      description={t("notAuthorized.description")}
      {...props}
    />
  );
};
